import { createContext } from 'react';

// Debug control - use i.e. DEBUG && console.log("whatever") and set below const true
const DEBUG = process.env.REACT_APP_DEBUG == 'enabled';

// Create Authentication context
export const AuthContext = createContext({
  user: null,
  setUser: () => {}
});